import { render } from "./ConfigurationList.vue?vue&type=template&id=1bef6659&scoped=true"
import script from "./ConfigurationList.vue?vue&type=script&lang=js"
export * from "./ConfigurationList.vue?vue&type=script&lang=js"

import "./ConfigurationList.vue?vue&type=style&index=0&id=1bef6659&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bef6659"

export default script